import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import { Props } from './BulkPrice.types';
import './BulkPrice.scss';

export const BulkPrice = ({
  discount,
  fromQuantity,
}: Props): ReactElement => {
  const t = useTranslate();
  const text = {
    line: t(
      'From {fromQuantity} pieces, <strong>CHF {discount}</strong> discount',
      {
        fromQuantity,
        discount: discount.toFixed(2),
      },
    ),
  };

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: text.line,
      }}
      className="BulkPrices-BulkPrice"
    />
  );
};
